import React from 'react';

import { Box, Table } from '@betterment/samba-react';

import { RewardTier } from '../../graphql/schema';

interface Props {
  rewardTiers?: RewardTier[];
  rewardConditionTitle: string;
  rewardTitle: string;
}

const RewardTiersTable: React.FC<Props> = ({ rewardTiers, rewardConditionTitle, rewardTitle }) => {
  if (!rewardTiers || rewardTiers.length === 0) return null;

  return (
    <Box css={{ padding: 'space.200', backgroundColor: 'background.neutral', marginTop: 'space.300' }}>
      <Table css={{ bg: 'background.neutral' }}>
        <Table.Header>
          <Table.Row>
            <Table.ColumnHeaderCell css={{ paddingTop: 'space.100' }}>{rewardConditionTitle}</Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell alignment="end" css={{ paddingTop: 'space.100' }}>
              {rewardTitle}
            </Table.ColumnHeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {rewardTiers.map((tier: RewardTier) => {
            return (
              <Table.Row key={tier.id} css={{ borderBottom: 'none' }}>
                <Table.Cell css={{ py: 'space.100' }}>{tier.conditionDescription}</Table.Cell>
                <Table.Cell css={{ py: 'space.100' }} alignment="end">
                  {tier.rewardDescription}
                </Table.Cell>
              </Table.Row>
            );
          })}
        </Table.Body>
      </Table>
    </Box>
  );
};
export default RewardTiersTable;
